import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class CorrelationService {

  constructor() { }

  private currentId: string | null = null;

  generate(): string | null {
    this.currentId = this.generateGuid();
    return this.currentId;
  }

  get(): string | null {
    return this.currentId;
  }

  clear(): void {
    this.currentId = null;
  }

  private generateGuid(): string {
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
      const r = Math.random() * 16 | 0;
      const v = c === 'x' ? r : (r & 0x3 | 0x8);
      return v.toString(16);
    });
  }

}
